/**
 * @generated SignedSource<<ce58d611252b9956cb488acbd8175ebf>>
 * @relayHash e100e4608f0f09869a047dc4d2e25a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 937157055e12959c4a5dedd3877600cd0531fb0e4b7826db78fa93e5143aa6d7

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TownsquareUnshardedAccessControlCapability = "ACCESS" | "ADMINISTER" | "CREATE" | "%future added value";
export type TownsquareUnshardedCapabilityContainer = "GOALS_APP" | "PROJECTS_APP" | "%future added value";
export type GoalsPopupQuery$variables = {
  cloudId: string;
  issueAri: string;
};
export type GoalsPopupQuery$data = {
  readonly townsquareUnsharded_allWorkspaceSummariesForOrg: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly cloudId: string;
        readonly name: string;
        readonly userCapabilities: {
          readonly capabilities: ReadonlyArray<{
            readonly capability: TownsquareUnshardedAccessControlCapability | null | undefined;
            readonly capabilityContainer: TownsquareUnshardedCapabilityContainer | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"issueGoals_AtlassianGoalPicker">;
};
export type GoalsPopupQuery = {
  response: GoalsPopupQuery$data;
  variables: GoalsPopupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "cloudId"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "concreteType": "TownsquareUnshardedUserCapabilities",
  "kind": "LinkedField",
  "name": "userCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUnshardedCapability",
      "kind": "LinkedField",
      "name": "capabilities",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "capability"
        },
        {
          "kind": "ScalarField",
          "name": "capabilityContainer"
        }
      ]
    }
  ]
},
v5 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "issueAri"
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  (v5/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "key"
},
v10 = [
  (v8/*: any*/)
],
v11 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v12 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v13 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v14 = [
  "id"
],
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalsPopupQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "issueGoals_AtlassianGoalPicker"
      },
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
        "kind": "LinkedField",
        "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TownsquareUnshardedWorkspaceSummary",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalsPopupQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
            "kind": "LinkedField",
            "name": "jiraEpicContributesToAtlasGoal",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          },
                          (v9/*: any*/),
                          {
                            "concreteType": "TownsquareStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "value"
                              },
                              {
                                "concreteType": "TownsquareLocalizationField",
                                "kind": "LinkedField",
                                "name": "localizedLabel",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "messageId"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          }
                        ],
                        "type": "TownsquareGoal"
                      },
                      (v11/*: any*/)
                    ]
                  },
                  (v12/*: any*/),
                  (v8/*: any*/)
                ]
              },
              (v13/*: any*/)
            ]
          },
          {
            "args": (v6/*: any*/),
            "filters": (v14/*: any*/),
            "handle": "connection",
            "key": "LinkedGoals_jiraEpicContributesToAtlasGoal",
            "kind": "LinkedHandle",
            "name": "jiraEpicContributesToAtlasGoal"
          },
          {
            "alias": "issueGoalPicker",
            "args": (v15/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection",
            "kind": "LinkedField",
            "name": "jiraEpicContributesToAtlasGoal",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "TownsquareGoal"
                      },
                      (v11/*: any*/)
                    ]
                  },
                  (v12/*: any*/),
                  (v8/*: any*/)
                ]
              },
              (v13/*: any*/)
            ]
          },
          {
            "alias": "issueGoalPicker",
            "args": (v15/*: any*/),
            "filters": (v14/*: any*/),
            "handle": "connection",
            "key": "Goals_issueGoalPicker",
            "kind": "LinkedHandle",
            "name": "jiraEpicContributesToAtlasGoal"
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
        "kind": "LinkedField",
        "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TownsquareUnshardedWorkspaceSummary",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "937157055e12959c4a5dedd3877600cd0531fb0e4b7826db78fa93e5143aa6d7",
    "metadata": {},
    "name": "GoalsPopupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6b6483c49f35e89caf438218f946dd41";

export default node;
